import React from "react";
import "./achievementComponent.css";
import OptimizedSlideshow from '../projects/OptimizedSlideshow';

import image1 from "./images/ATEC1.jpeg";
import image2 from "./images/ATEC2.jpeg" ;




const IEEE = () => {
    const images = [image1,image2];

    return (
    <section className="RedRadio section" id="RedRadio">
        <h2 className="section__title">IEEE ATEC</h2>
        <span className="section__subtitle">First place winner🥇</span>
        <OptimizedSlideshow mediaItems={images} />
        
        <div className="about__container container grid">
           

            <div className="text__container1">
                <h3 className="title">Description:</h3>
                <div className="achievement__content">
                    <p className='redRadio__text'>
                        🏆 <strong>1st Place Winner</strong> at the <strong>IEEE ATEC (Aerospace Technologies Challenge)</strong> hackathon — a 24-hour innovation marathon! 🌌
                    </p>
                    <p className='redRadio__text'>
                        💡 Collaborated with my team to develop <strong>Deimos</strong>, a project showcasing creativity and advanced tech in <strong>space exploration</strong>.
                    </p>
                    <p className='redRadio__text'>
                        🚀 Recognized for innovation, teamwork, and impact, marking a milestone in my journey within <strong>Aerospace Technologies</strong>. ✨
                    </p>
                </div>
            </div>
        </div>
    </section>
    );
};

export default IEEE;
